/** Created by azhou on 2019/3/13.*/
<template>
    <div>
      <public-title>发票管理</public-title>
      <div class="border rounded p-3  d-center-between flex-wrap">
        <left-text-border class="w-45" leftText="订单号" v-model="formData.oid"  @enter="getSearchCon"/>
        <left-text-border class="w-45" leftText="团号" v-model="formData.title" @enter="getSearchCon"/>
        <el-button type="primary" size="small" icon="el-icon-search" @click="getSearchCon" style="width: 120px;">搜索</el-button>
      </div>
      <!-- <SearchCon ref="searchCon" class="mop-none" :orderType="storeInfo.type" @getSearchCon="getSearchCon"/> -->
      <div class="load-area-container">
        <div v-if="total<=0" class="theContent">
          <img src="/images/order/icon_28.jpg">
          <p>当前没有数据</p>
        </div>
        <div v-else>
          <ul class="invoice-title">
              <li  v-for="item in storeInfo.type==2?titleTravel : titleHotel" :key="item" >{{item}}</li>
          </ul>
          <ul class="invoice-list">
            <li v-for="(item,index) in list" :key="item.id">  
              <p>{{ item.date_in | formatTimestamp(2)}}</p>
              <p>{{ item.oid}}</p>
              <p v-if="storeInfo.type==2">{{ item.title}}</p>
              <p v-if="storeInfo.type==2">{{ item.hotel_title}}</p>
              <p v-if="storeInfo.type!=2">{{ item.travel_title}}</p>
              <p v-if="storeInfo.type!=2">{{ item.send_name}}</p>
              <!-- <p @click="uploadInvoice({receipt:item.offer_receipt,type:2,item:item})">
                <span v-if="item.offer_receipt" class="text-primary"><i class="iconfont icon-yanjing-"></i>查看</span>
                <span v-else class="text-danger">—</span>
              </p> -->
              <p><span class="text-price"><span>¥</span>{{item.price}}</span></p>
              <p @click="checkInvoice(item,index)">
                <span v-if="item.pdfUrl" class="text-primary"><i class="iconfont icon-yanjing-"></i>查看</span>
                <span v-else class="text-danger">—</span>
              </p>
              <p :class="[$GFUN.FormatColor(item.status||item.offer_status)]">{{(item.status||item.offer_status)|formatVar(orderStatusArr)}}</p>
              <p class="text-arrow" @click="goForDetail(item)">
                <span>详情<i class="el-icon-arrow-right"></i></span> 
              </p>
            </li>
          </ul> 
          <el-pagination background layout="prev, pager, next" class="mt-4" :page-size="formData.num" :total="total" :current-page="Number(formData.page)" @current-change="v => formData.page=v"/>
        </div>
      </div>
      <el-dialog
        :visible.sync="invoiceVisible"
        :show-close="false"
        :close-on-click-modal="false"
        width="1140px"
        class="invoice-dialog"
      >
        <div class="invoice-info">
          <p>订单号：{{invoiceItem.oid}}</p>
          <!-- <p>团号：{{invoiceItem.title}}</p> -->
          <p>酒店名称：{{invoiceItem.hotel_title}}</p>
          <p>订单金额：<span class="text-price"><span>¥</span>{{invoiceItem.price}}</span></p>
          <div class="close-btn" @click="invoiceVisible=false"><i class="el-icon-close"></i></div>
        </div>
        <div class="invoice-thumb-box" v-loading="loading">
          <div class="arrow" @click="prevInvoice" :class="{'disabled':invoiceIndex<=0}"><i class="iconfont icon-jiantouyou"></i></div>
          <InvoiceAlbum :invoiceItem="invoiceItem"></InvoiceAlbum>
          <div class="arrow arrow-right" @click="nextInvoice" :class="{'disabled':invoiceIndex>=list.length-1}"><i class="iconfont icon-right"></i></div>
        </div>  
      </el-dialog>
      <!-- <iframe
      src="https://cdn.yudingdan.cn/llDik4B5y6OoMrmHSMLsfT-ujZ1G"
      width="100%"
      height="700px"
      frameborder="0"
    ></iframe> -->
    </div>
</template>

<script>
  import { mapGetters, mapActions,mapState,mapMutations } from 'vuex'
  // import SearchCon from '@/views/Order/OrderLists/SearchCon'                                            //搜索条件
  import InvoiceAlbum from '@/views/StoreInfo/InvoiceInfo/components/InvoiceAlbum.vue'
  export default {
    name: 'StoreInvoiceLists',
    computed: {
      ...mapGetters(['storeInfo','isGroup']),
      orderStatusArr() {
        switch (this.storeInfo.type) {
          case 99:
          case 2: return 'TOrderStatus';
          case 3: return 'HOrderStatus';
          default:return '';
        }
      },
    },
    components:{
      SearchCon,
      InvoiceAlbum,
    },
    watch:{
      'formData.page':{
        handler(newVal,oldVal){
          this.Initial();
        },
      },
    },
    data() {
      return {
        formData:{                      //列表参数
          page:1,
          num:15,
          title:'',                     //团号
          oid:'',                        //订单号
        },
        list:[],                       //列表
        searchCon:{},                  //搜索条件
        total:0,                       //总条数
        titleTravel :['入住时间','订单号','团号','酒店','订单金额','发票','状态','操作'],
        titleHotel:['入住时间','订单号','采购商','发单人','订单金额','发票','状态','操作'],
        invoiceVisible:false,             //查看发票弹窗
        invoiceIndex:0,                  //查看发票索引
        invoiceItem:{},                  //查看发票详情
        loading:false,                    //loading状态
      }
    },
    mounted() {
      this.Initial();
    },
    methods:{
      ...mapActions(['POST_OrderHotelReceiptList']),
      searchSubmit(){
        this.Initial();
      },
      //发票列表
      Initial(){
        this.POST_OrderHotelReceiptList({data:{...this.formData,...this.searchCon},successFun:(res) => {
          //合并发票列表
          res.list.forEach(item => {
            item.pdfUrl = item.send_receipt+(item.offer_receipt?','+item.offer_receipt:'');
          })
          this.list = res.list;
          this.total = res.count;
        }});
      },
      /*跳转查看订单详情页*/
      goForDetail(cardItem) {
        let routeUrl = this.$router.resolve({
          name: 'OrderDetail',
          query: {
            orderType: this.storeInfo.type,
            orderId: cardItem.oid,
            match_store_id:this.storeInfo.storeId,
          }
        });
        window.open(routeUrl.href, '_blank');
      },
      /*根据条件搜索订单*/
      getSearchCon(con) {
        if (this.formData.page == 1) {this.loading = true;this.Initial()}
        else {
          this.$router.push({
            name: this.$route.query.name,
            query: {...this.formData, page: 1}
          })
        };
      },
      //查看发票
      checkInvoice(item,index){
        this.invoiceVisible = true;
        this.invoiceIndex = index;
        this.invoiceItem = item;
      },
      //查看下一个
      nextInvoice(){
        if(this.invoiceIndex < this.list.length - 1){
          //显示加载0.5秒关闭
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
          }, 500);
          this.invoiceIndex++;
          this.invoiceItem = this.list[this.invoiceIndex];
        }
      },
      //查看上一个
      prevInvoice(){
        if(this.invoiceIndex > 0){
          //显示加载0.5秒关闭
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
          }, 500);
          this.invoiceIndex--;
          this.invoiceItem = this.list[this.invoiceIndex];
        }
      }
    },
  }
</script>
<style scoped>
  .border{
    background-color: #fff;
    margin-bottom: 20px;
  }
  .mop-none{
    background-color: #fff;
    padding-bottom: 20px !important;
    border:initial !important;
    border-radius:6px 6px 0 0 !important;
  }
  .load-area-container{
    background: #ffffff;
    border-radius: 0 0 6px 6px;
    min-height: 75vh;
    overflow: hidden;
  }
.invoice-title{
  display: flex;
  background-color: #fafbfc;
  border-right: 6px;
  overflow: hidden;
}
.invoice-title li{
  width: 50%;
  color: #99a1af;
  font-weight: bold;
  line-height: 60px;
}

.invoice-list li{
  display: flex;
}
.invoice-list li p{
  width: 50%;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 60px;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
}
.invoice-list li p:nth-child(n+4),.invoice-title li:nth-child(n+4){
  width: 30%;
}
.invoice-list li:hover{
  background-color: #fafbfc;
}
.text-primary{
   background-color: #f2f7fe;
   width: 80px;
   height: 30px;
   line-height: 30px;
   text-align: center;
   border-radius: 5px;
   margin: 0 auto;
   font-size: 12px;
   display: flex;
   justify-content: center;
   align-items: center;
}
.text-primary i{
  margin-right: 3px;
}
.text-danger{
  color: #999 !important;
}
.invoice-list li .text-arrow span{
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--smtc-color-primary );
}
.invoice-list li .text-arrow i{
  margin-top: 3px;
  margin-left: 3px;
}
.text-price{
  color: var(--smtc-color-text-red);
  font-weight: bold;
}
.text-price span{
  font-size: 10px;
  margin-right: 1px;
}
.invoice-info{
  display: flex;
  justify-content: left;
  line-height: 60px;
  width: 1000px;
  margin: 0 auto;
  margin-top: -20px;
}
.invoice-info p{
  margin-right: 16px;
}
.close-btn{
  margin-left: auto;
  background-color: #f5f5f5;
  width: 30px;
  height: 30px;
  line-height: 30px;
  margin-top: 15px;
  border-radius: 50%;
  color: #999;
  cursor: pointer;
}
.invoice-thumb-box{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.arrow{
  width: 40px;
  height: 40px;
  background-color: #f5f5f5;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 16px;
  margin-top: -45px;
  cursor: pointer;
  color:var( --smtc-color-primary);
  font-weight: bold;
}
.arrow i{
  font-size: 14px;
} 
.arrow-right{
  margin-left: 0; 
  margin-right: 16px;
}
.disabled{
  color: #dbdbdb;
}
.theContent{
  text-align: center;
  margin-top: 12%;
  color: #999;
}
</style>
<style>
  .invoice-dialog .el-dialog__header,.invoice-dialog .el-dialog__body{
    padding:0 !important;
    padding-bottom: 20px !important;
  }
</style>